import React from 'react';
import ClearAllButton from './ClearAllButton';

interface LabelProps {
    title: string;
    onClearAll: () => void;
}

const Label = ({ title, onClearAll }: LabelProps) => {
    return (
        <div className="flex items-center justify-between">
            <span className="text-foreground text-sm font-medium">{title}</span>
            <ClearAllButton onClearAll={onClearAll} />
        </div>
    );
};

export default Label;
